// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__2hONw","header":"styles_header__mGY9V","name":"styles_name__xHoXM","date":"styles_date__3dAxn","text":"styles_text__1H4QU"};